<template>
  <div>
    <q-fab :class="buttonClass" :label="mobile ? '' : webentity ? webentity.title : ''" label-position="left" color="primary" text-color="white" :icon="mobile ? 'keyboard_arrow_right' : 'keyboard_arrow_down'" :direction="mobile ? 'right' : 'down'" padding="xs">
      <div :class="styleClass">
        <div v-html="computedContent">
        </div>
      </div>
    </q-fab>
  </div>
</template>

<script>
import { useQueryStore } from 'src/stores/QueryStore'
export default {
  name: 'webentityOverlay',
  props: {
    map: Object,
    webentityName: String
  },

  data() {
    return {
      mobile: false,
      webentity: null
    }
  },

  computed: {
    styleClass() {
      return {
        'webentityOverlay': !this.mobile,
        'webentityOverlayMobile': this.mobile
      }
    },
    buttonClass() {
      return {
        'btnFabWO': !this.mobile,
        'btnFabWOMobile': this.mobile
      }
    },
    computedContent(){
      if(this.webentity && this.webentity.content){
        return this.webentity.content
      } else {
        return "Kein ContentEntity konfiguriert"
      }
    }
  },

  methods: {
  readWebentity() {
    if(this.webentityName){
      const queryStore = useQueryStore()
      queryStore.webEntityGet({ webEntityName: this.webentityName})
        .then((we) => {
          this.webentity = we
        })
      }
    }
  },

  async mounted() {
    if (this.$q.screen.name == 'xs') {
      this.mobile = true
    }
    this.readWebentity()
  }
}
</script>

<style lang="sass">
.webentityOverlay
  background-color: white
  border-radius: 1px
  width: 500px
  min-height: 100px
  max-height: 300px
  overflow: auto
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2)
  padding: 10px
  font-size:14px


.webentityOverlayMobile
  background-color: white
  border-radius: 1px
  width: 250px
  min-height: 100px
  max-height: 150px
  overflow: auto
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2)
  padding: 10px
  font-size:14px


.btnFabWO
  position: absolute
  left: 425px
  top:15px


.btnFabWOMobile
  position: absolute
  left: 10px
  top:100px

</style>
